import { ReactNode } from 'react';
import {
  FULL_DATETIME_WITH_TIMEZONE_AND_OFFSET_FORMAT,
  MONTH_DAY_YEAR_DATETIME_FORMAT,
} from '@dealroadshow/uikit-date-time/dateFormats';
import type { ITimeZone } from '@dealroadshow/uikit-date-time';
import { DEFAULT_TIME_ZONE } from '@framework/timezone/constants';
import { getAndFormatDateFromString } from '@/condor/ui/common/Layout/helpers';

import styles from './styles.module.scss';

interface IProps {
  children?: ReactNode,
  author: string,
  date: string,
  authorDataTest: string,
  dateDataTest: string,
  /** Zone the date is rendered in. Callers outside CreditFlow (e.g. Condor previews)
   * have no user zone and fall back to DEFAULT_TIME_ZONE. */
  timeZone?: ITimeZone,
}

export const Metadata = ({
  children,
  author,
  date,
  authorDataTest,
  dateDataTest,
  timeZone = DEFAULT_TIME_ZONE,
}: IProps) => {
  const formatedDate = getAndFormatDateFromString(
    date,
    {
      parseFormat: FULL_DATETIME_WITH_TIMEZONE_AND_OFFSET_FORMAT,
      formatString: MONTH_DAY_YEAR_DATETIME_FORMAT,
      timeZone,
    },
  );

  return (
    <div className={ styles.metadata }>
      { children }
      <p className={ styles.author } data-test={ authorDataTest }>{ `by ${ author }` }</p>
      { date && (
        <p className={ styles.date } data-test={ dateDataTest }>{ formatedDate } { timeZone.abbr }</p>
      ) }
    </div>
  );
};
